export default __webpack_public_path__ + "static/media/HDTX_Riwayat Hidup Calon Anggota Dewan Komisaris 2023-2028.3fd23faf.pdf";